import KindergartenMenu from "../Component/kindergartenMenu";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload';
const KidsFeeDetails = () => {
    return (
        <>
         <KindergartenMenu />
            <Breadcrumb title="Yearly Fees Details (Year 2025-2026)" mid="Kindergarten &nbsp; &nbsp;|" tabName="Yearly Fees Details (Year 2025-2026)" />
            <div className="innerPage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div class="table-responsive table-wid">
                                <table className="table">
                                    <thead>
                                        <tr><th rowSpan={2}>Class</th>
                                            <th colSpan={3}>For year 2025-26 FEES (in rupees)</th>
                                        </tr>
                                        <tr>
                                            <th>Tuition Fees</th>
                                            <th>Term Fees</th>
                                            <th>Total Fees</th>
                                            
                                            </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>NURSERY</td>
                                            <td>54176</td>
                                            <td>9030</td>
                                            <td>63206</td>
                                        </tr>
                                        <tr>
                                            <td>LKG</td>
                                            <td>54176</td>
                                            <td>9030</td>
                                            <td>63206</td>
                                        </tr>
                                        <tr>
                                            <td>HKG</td>
                                            <td>51700</td>
                                            <td>8616</td>
                                            <td>60316</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default KidsFeeDetails;